import React from 'react';
import SignInLayout from '../../components/layout/signin';
import SignUpLayout from '../../components/layout/signup';
import AsyncSignIn from './signin/async';
import AsyncSignUp from './signup/async';

export default [
  <SignInLayout exact key="a" path="/sign-in" component={AsyncSignIn} />,
  <SignUpLayout exact key="b" path="/sign-up" component={AsyncSignUp} />,
];
